// @core/api/endpoints/fiscalization/close_shift.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CloseShiftRequest,
  CloseShiftResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Close fiscal shift
 * Closes the current shift on a fiscal point. Generates a shift close report with totals sent to the fiscal provider.
 */
export async function CloseShift(
  fiscalPointId: string,
  data: CloseShiftRequest,
  options?: RequestOptions
): Promise<CloseShiftResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:fiscalPointId/shifts/close`;
  requestPath = requestPath.replace(':fiscalPointId', encodeURIComponent(fiscalPointId));
  const requestOptions = options;
  return client.post<CloseShiftResponse>(requestPath, data, requestOptions);
}
